import React, { useState } from "react";
import styles from "./ctahome.module.css";
import AppointmentModal from "../../components/appointmentModal/AppointmentModal.js";

const CTAHome = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={styles.ctaSection}>
      <div className={styles.overlay}></div>
      <div className={styles.content}>
        <h2 className={styles.title}>
          Compassionate Care, Advanced Treatment
        </h2>
        <p className={styles.subtitle}>
          Your Health • Our Priority
        </p>
        <button
          className={styles.ctaButton}
          onClick={() => setIsModalOpen(true)}
        >
          Schedule an Appointment
        </button>
      </div>

      {/* Popup Appointment Form */}
      <AppointmentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default CTAHome;
